<div class="queryInputSection">
  <ng-container [ngSwitch]="mode">
    <free-form-filter *ngSwitchCase="smartSearchMode.SIMPLE" [queryExpression]="queryExpression"
      [treatEmptyAsValid]="treatEmptyAsValid" [readonlyChipState]="readonlyChipState"
      [layoutPreferences]="layoutPreferences" (inputChanged)="inputChangedListener($event)"
      (inputFieldChangeEvent)="inputFieldChangeListener($event)" [isAnalytics]="isAnalytics">
    </free-form-filter>

    <smart-search-expert *ngSwitchCase="smartSearchMode.EXPERT" [queryExpression]="queryExpression"
      [treatEmptyAsValid]="treatEmptyAsValid" [layoutPreferences]="layoutPreferences"
      (inputChanged)="inputChangedListener($event)">
    </smart-search-expert>
  </ng-container>

  <div class="btn-icon-container">
    <button *ngIf="isClearAllVisibile" mat-button mat-icon-button matTooltip="Clear all filters"
      aria-label="Clear all filters" class="clear-all" (click)="clearAll()">
      <span class="mdi mdi-filter-remove-outline"></span>
    </button>

    <!-- Temporary hide expert mode (OLPTC-6068) -->
    <!-- <button
      mat-button
      mat-icon-button
      matTooltip="Switch between expert and simple modes"
      aria-label="Switch between expert and simple modes"
      (click)="switchMode()"
      [disabled]="!switchingAllowed"
      *ngIf="!layoutPreferences?.hideModeSwitch"
      class="mode-switch"
    >
      <mat-icon>code</mat-icon>
    </button> -->

    <button mat-button mat-icon-button aria-label="Validate expression"
      *ngIf="!layoutPreferences?.hideValidStatus && mode === smartSearchMode.EXPERT" class="validate-query">
      <mat-icon>{{ queryValidStatus }}</mat-icon>
    </button>

    <nrwl-helpicon *ngIf="!layoutPreferences?.hideHelpIcon" [helpId]="'homeFreeFormFilter'"></nrwl-helpicon>
  </div>
</div>